var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wh100"},[_c('el-row',{attrs:{"gutter":_vm.gutter}},[_c('el-col',{attrs:{"span":_vm.span[0]}},[_vm._t("left")],2),_c('el-col',{attrs:{"span":_vm.span[1]}},[_vm._t("right")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }